import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faThermometerThreeQuarters,
  faCog,
  faSun,
  faTimes,
  faPowerOff,
  faEllipsisV,
  faCheckCircle,
  faAngleUp,
  faClock,
  faAngleDown,
  faSyncAlt,
  faAngleRight,
  faCouch,
  faGamepad,
  faToilet,
  faMapSigns,
  faBuilding,
  faUtensils,
  faBath,
  faToiletPaper,
  faShoePrints,
  faCogs,
  faArrowsAltH,
  faHome,
  faSearch,
  faLifeRing,
  faStar,
  faMap,
  faPersonBooth,
  faCoffee,
  faLightbulb,
  faFilm,
  faBolt,
  faBars,
  faNetworkWired,
  faExclamationCircle,
  faSlidersH,
  faEnvelope,
  faChartLine,
  faPlus,
  faPen,
  faFileCsv,
  faFilePdf,
  faFileExcel,
  faTable,
  faCommentAlt,
  faCheck,
  faSignInAlt,
  faArrowRight,
  faCircle as fasCircle,
  faUserPlus,
  faUserShield,
  faUser,
  faUsers,
  faTrashAlt,
  faCalendar,
  faImage,
  faShareAlt,
  faTh,
  faTint,
  faViruses,
  faHatWizard,
  faQuestionCircle,
  faMicrochip,
  faServer,
  faEthernet,
  faWifi,
  faTimesCircle,
  faFileAlt,
  faSignOutAlt,
  faKey,
  faExclamationTriangle,
  faInfoCircle,
  faCopy,
  faFileInvoice,
} from '@fortawesome/free-solid-svg-icons';
import {
  faCircle as farCircle,
} from '@fortawesome/free-regular-svg-icons';

library.add(
  faThermometerThreeQuarters,
  faCog,
  faSun,
  faTimes,
  faPowerOff,
  faEllipsisV,
  faCheckCircle,
  faAngleUp,
  faClock,
  faAngleDown,
  faSyncAlt,
  faAngleRight,
  faCouch,
  faGamepad,
  faToilet,
  faMapSigns,
  faBuilding,
  faUtensils,
  faBath,
  faToiletPaper,
  faShoePrints,
  faCogs,
  faArrowsAltH,
  faHome,
  faSearch,
  faLifeRing,
  faStar,
  faMap,
  faPersonBooth,
  faCoffee,
  faLightbulb,
  faFilm,
  faBolt,
  faBars,
  faNetworkWired,
  faExclamationCircle,
  faSlidersH,
  faEnvelope,
  faChartLine,
  faPlus,
  faPen,
  faFileCsv,
  faFilePdf,
  faCommentAlt,
  faCheck,
  faSignInAlt,
  faArrowRight,
  fasCircle,
  farCircle,
  faUserPlus,
  faUserShield,
  faTrashAlt,
  faCalendar,
  faImage,
  faShareAlt,
  faFileExcel,
  faTable,
  faTh,
  faTint,
  faViruses,
  faHatWizard,
  faQuestionCircle,
  faMicrochip,
  faServer,
  faEthernet,
  faWifi,
  faTimesCircle,
  faUser,
  faUsers,
  faFileAlt,
  faSignOutAlt,
  faKey,
  faExclamationTriangle,
  faInfoCircle,
  faCopy,
  faFileInvoice,
);
